import { createReducer } from 'reduxsauce';
import actions from './actions';

const { Types } = actions;
const INITIAL_STATE = {
  isRequesting: false,
  freezeDropdownDetails: {},
  cancelDropdownDetails: {},
  isSubmitFreezeLoading: false,
  freezeFormDetails: {},
  isSubmitCancelLoading: false,
  cancelFormDetails: {},
  isCancelUrlLoading: false,
  cancelIframeDetails: {},
  isFreezeUrlLoading: false,
  freezeIframeDetails: {},
  isFormsDetailsLoading: false,
  formsDetails: {},
  error: null,
};

const request = (state = INITIAL_STATE) => {
  return {
    ...state,
    isRequesting: true,
    error: null,
  };
};

const loadFreezeDropdownDataSuccess = (
  state = INITIAL_STATE,
  { freezeDropdownDetails }
) => {
  return {
    ...state,
    isRequesting: false,
    freezeDropdownDetails,
  };
};

const loadCancelDropdownDataSuccess = (
  state = INITIAL_STATE,
  { cancelDropdownDetails }
) => {
  return {
    ...state,
    isRequesting: false,
    cancelDropdownDetails,
  };
};

const failure = (state = INITIAL_STATE, { error }) => {
  return {
    ...state,
    isRequesting: false,
    freezeDropdownDetails: {},
    cancelDropdownDetails: {},
    error,
  };
};

const submitFreezeRequest = (state = INITIAL_STATE) => {
  return {
    ...state,
    isSubmitFreezeLoading: true,
    error: null,
  };
};

const submitFreezeSuccess = (state = INITIAL_STATE, { freezeFormDetails }) => {
  return {
    ...state,
    isSubmitFreezeLoading: false,
    freezeFormDetails,
  };
};

const submitFreezeFailure = (state = INITIAL_STATE, { error }) => {
  return {
    ...state,
    isSubmitFreezeLoading: false,
    freezeFormDetails: {},
    error,
  };
};

const submitCancelRequest = (state = INITIAL_STATE) => {
  return {
    ...state,
    isSubmitCancelLoading: true,
    error: null,
  };
};

const submitCancelSuccess = (state = INITIAL_STATE, { cancelFormDetails }) => {
  return {
    ...state,
    isSubmitCancelLoading: false,
    cancelFormDetails,
  };
};

const submitCancelFailure = (state = INITIAL_STATE, { error }) => {
  return {
    ...state,
    isSubmitCancelLoading: false,
    cancelFormDetails: {},
    error,
  };
};

const loadCancelIframeUrlRequest = (state = INITIAL_STATE) => {
  return {
    ...state,
    isCancelUrlLoading: true,
    error: null,
  };
};

const loadCancelIframeUrlSuccess = (state = INITIAL_STATE, { cancelIframeDetails }) => {
  return {
    ...state,
    isCancelUrlLoading: false,
    cancelIframeDetails,
  };
};

const loadCancelIframeUrlFailure = (state = INITIAL_STATE, { error }) => {
  return {
    ...state,
    isCancelUrlLoading: false,
    cancelIframeDetails: {},
    error,
  };
};

const loadFreezeIframeUrlRequest = (state = INITIAL_STATE) => {
  return {
    ...state,
    isFreezeUrlLoading: true,
    error: null,
  };
};

const loadFreezeIframeUrlSuccess = (state = INITIAL_STATE, { freezeIframeDetails }) => {
  return {
    ...state,
    isFreezeUrlLoading: false,
    freezeIframeDetails,
  };
};

const loadFreezeIframeUrlFailure = (state = INITIAL_STATE, { error }) => {
  return {
    ...state,
    isFreezeUrlLoading: false,
    freezeIframeDetails: {},
    error,
  };
};

const loadFormsDetailsRequest = (state = INITIAL_STATE) => {
  return {
    ...state,
    isFormsDetailsLoading: true,
    error: null,
  };
};

const loadFormsDetailsSuccess = (state = INITIAL_STATE, { formsDetails }) => {
  return {
    ...state,
    isFormsDetailsLoading: false,
    formsDetails,
  };
};

const loadFormsDetailsFailure = (state = INITIAL_STATE, { error }) => {
  return {
    ...state,
    isFormsDetailsLoading: false,
    formsDetails: {},
    error,
  };
};

const resetCancelFormDetails = (state = INITIAL_STATE) => {
  return {
    ...state,
    cancelFormDetails: {},
  };
};

const resetFreezeFormDetails = (state = INITIAL_STATE) => {
  return {
    ...state,
    freezeFormDetails: {},
  };
};

const resetIframeDetails = (state = INITIAL_STATE) => {
  return {
    ...state,
    cancelIframeDetails: {},
    freezeIframeDetails: {},
    isCancelUrlLoading: false,
    isFreezeUrlLoading: false,
  };
};

export const HANDLERS = {
  [Types.LOAD_FREEZE_DROPDOWN_DATA_REQUEST]: request,
  [Types.LOAD_FREEZE_DROPDOWN_DATA_SUCCESS]: loadFreezeDropdownDataSuccess,
  [Types.LOAD_FREEZE_DROPDOWN_DATA_FAILURE]: failure,

  [Types.LOAD_CANCEL_DROPDOWN_DATA_REQUEST]: request,
  [Types.LOAD_CANCEL_DROPDOWN_DATA_SUCCESS]: loadCancelDropdownDataSuccess,
  [Types.LOAD_CANCEL_DROPDOWN_DATA_FAILURE]: failure,

  [Types.SUBMIT_FREEZE_REQUEST]: submitFreezeRequest,
  [Types.SUBMIT_FREEZE_SUCCESS]: submitFreezeSuccess,
  [Types.SUBMIT_FREEZE_FAILURE]: submitFreezeFailure,

  [Types.SUBMIT_CANCEL_REQUEST]: submitCancelRequest,
  [Types.SUBMIT_CANCEL_SUCCESS]: submitCancelSuccess,
  [Types.SUBMIT_CANCEL_FAILURE]: submitCancelFailure,

  [Types.LOAD_CANCEL_IFRAME_URL_REQUEST]: loadCancelIframeUrlRequest,
  [Types.LOAD_CANCEL_IFRAME_URL_SUCCESS]: loadCancelIframeUrlSuccess,
  [Types.LOAD_CANCEL_IFRAME_URL_FAILURE]: loadCancelIframeUrlFailure,

  [Types.LOAD_FREEZE_IFRAME_URL_REQUEST]: loadFreezeIframeUrlRequest,
  [Types.LOAD_FREEZE_IFRAME_URL_SUCCESS]: loadFreezeIframeUrlSuccess,
  [Types.LOAD_FREEZE_IFRAME_URL_FAILURE]: loadFreezeIframeUrlFailure,

  [Types.LOAD_FORMS_DETAILS_REQUEST]: loadFormsDetailsRequest,
  [Types.LOAD_FORMS_DETAILS_SUCCESS]: loadFormsDetailsSuccess,
  [Types.LOAD_FORMS_DETAILS_FAILURE]: loadFormsDetailsFailure,

  [Types.RESET_CANCEL_FORM_DETAILS]: resetCancelFormDetails,
  [Types.RESET_FREEZE_FORM_DETAILS]: resetFreezeFormDetails,
  [Types.RESET_IFRAME_DETAILS]: resetIframeDetails,
};

export default createReducer(INITIAL_STATE, HANDLERS);
